// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigModelType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
        return this.description ? `${this.name} (${this.description})` : this.name;
    }

    get hasConfigOptions() {
      //the database field hasOptions is being repurposed to show Config Options
        return this.hasOptions;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  displayOrder?: number;
  hasAxles!: boolean;
  hasBrakes!: boolean;
  hasOptions!: boolean;
  hasPolyCarpetOption!: boolean;
  hasSuspension!: boolean;
  hasTailOption!: boolean;
  hasToonOption!: boolean;
  hasTreeOptions!: boolean;
  hasWinchStand!: boolean;
  name?: string;
}

